module.exports = __webpack_public_path__ + "static/media/24UHCHR7.aa877cb9.jpg";